import { MgLocalStorageKeys } from '@enums';

export const getTokenFromStore = (): string | null => {
  return localStorage.getItem(MgLocalStorageKeys.TOKEN);
};
